export var SitecoreTemplateId;
(function (SitecoreTemplateId) {
    // /sitecore/templates/Foundation/JavaScript Services/App
    SitecoreTemplateId["JssApp"] = "061cba1554744b918a0617903b102b82";
    // /sitecore/templates/System/Dictionary/Dictionary entry
    SitecoreTemplateId["DictionaryEntry"] = "6d1cd89719364a3aa511289a94c2a7b1";
})(SitecoreTemplateId || (SitecoreTemplateId = {}));
export const FETCH_WITH = {
    GRAPHQL: 'GraphQL',
    REST: 'REST',
};
export const JSS_MODE = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
};
export const siteNameError = 'The siteName cannot be empty';
export const SITECORE_EDGE_URL_DEFAULT = 'https://edge-platform.sitecorecloud.io';
export const HIDDEN_RENDERING_NAME = 'Hidden Rendering';
